import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { fiPackageTypeName } from '../customer-billing-customer/package-type';

@Pipe({
    name: 'fiPackageTypeName',
    standalone: false,
})
export class PackageTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiPackageTypeName(value, this.appText);
    }
}
